import { QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE } from '@apps-common/apis/my-monitoring/site'
import { QUERY_MY_MONITORING_GET_MY_MONITORING_USER, QUERY_MY_MONITORING_GET_SITE_USERS } from '@apps-common/apis/my-monitoring/users'
import { QUERY_KEY_GET_MY_MONITORING_ACCOUNT } from '@apps-common/apis/portal/my-monitoring'
import { QUERY_GET_UNIT_TRAFFIC_INFINITE } from '@apps-common/apis/portal/unit/get-unit-traffic-infinite'
import { QUERY_GET_UNIT_SITE_USERS } from '@apps-common/apis/portal/users'
import {
  MyMonitoringUserAddForm,
  MyMonitoringUserUpdateForm
} from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/modals/my-monitoring-modify-modal'
import { ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { queryClient } from '@apps-common/lib'

export interface IMyMonitoringUserModifyModalProps {
  unit: {
    unitId: string
    ipAddress: string
    imei: string
  }
  userId?: number
  existingIds: number[]
}

export const MyMonitoringUserModifyModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IMyMonitoringUserModifyModalProps
}) => {
  const { unit, userId, existingIds } = componentProps
  const { unitId } = unit || {}
  const isEditing = userId !== undefined

  const refetchQueries = (role: string) => {
    if (role === ModalDismiss.Confirm) {
      // my monitoring
      queryClient.invalidateQueries({ queryKey: QUERY_MY_MONITORING_GET_MY_MONITORING_USER(unitId, userId) })
      queryClient.invalidateQueries({ queryKey: QUERY_MY_MONITORING_GET_SITE_USERS(unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE() })
      // portal
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_MY_MONITORING_ACCOUNT(userId) })
      queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_SITE_USERS(unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE() })
    }
  }

  return (
    <ModalContainer innerClasses='!min-h-[140px] !h-auto'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={isEditing ? 'Update' : 'Create'} title='myMonitoring user' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      {!isEditing && (
        <MyMonitoringUserAddForm
          unitId={unitId}
          existingUserIds={existingIds}
          closeCb={(role: string) => {
            refetchQueries(role)
            onDismiss(null, role)
          }}
        />
      )}
      {isEditing && (
        <MyMonitoringUserUpdateForm
          userId={userId}
          unitId={unitId}
          closeCb={(role: string) => {
            refetchQueries(role)
            onDismiss(null, role)
          }}
        />
      )}
    </ModalContainer>
  )
}
